import React from "react";
import "./DisplayMessage.css";

function DisplayMessage({ type, message, className = "" }) {
  if (!message) return null;

  const alertClass = `display-message display-message-${type} ${className}`;

  return <div className={alertClass}>{message}</div>;
}

export default DisplayMessage;
